import { UserAvatar } from 'Components/shared/UserAvatar';
import { MobXProviderContext, observer } from 'mobx-react';
import React from 'react';
import { RootStoreProps } from 'Stores/RootStore.types';
import { HistoryChatBubbleProps } from './index.types';

export const HistoryChatBubble: React.FC<HistoryChatBubbleProps> = observer(
  ({ text, personId, displayName, timestamp, testId }) => {
    const {
      person: personStore,
      ui: uiStore,
      conversation: conversationStore,
    } = React.useContext<RootStoreProps>(MobXProviderContext);

    const presence = uiStore.selectPersonPresenceStatus(personId);

    // Guest users have personId 0. Skip PersonStore lookup so we don't incorrectly
    // cache a fallback under "0" in the shared PersonStore
    const person =
      Number(personId) > 0
        ? personStore.selectPersonValueById(Number(personId))
        : null;

    const isPhone =
      conversationStore.phoneParticipantDisplayNames.has(displayName);

    const personName = person?.name || displayName;
    const personImage = person?.avatarUrl || undefined;
    const personDeleted = person?.deleted || false;

    const componentTestId = testId ?? 'history-chat-bubble';

    return (
      <div className="mb-4.5" data-testid={componentTestId}>
        <div className="flex items-center gap-4 mb-2.5 min-w-0">
          <div className="shrink-0">
            {isPhone ? (
              <UserAvatar isPhone />
            ) : (
              <UserAvatar
                name={personName}
                image={personImage}
                presence={presence}
                isInactive={personDeleted}
              />
            )}
          </div>
          <span
            className="flex-1 min-w-0 truncate text-body font-bold"
            title={personName}
          >
            {personName}
          </span>
          <span className="shrink-0 text-subtitles text-grey-700">
            {timestamp}
          </span>
        </div>

        {Array.isArray(text) ? (
          text.map((text, index) => (
            <div className="pl-[44px] text-body" key={index}>
              {text}
            </div>
          ))
        ) : (
          <div className="pl-[44px] text-body">{text}</div>
        )}
      </div>
    );
  }
);
